import { ReactNode } from 'react';

import { DetailsListItem } from '../DetailsListItem/DetailsListItem';

export const DetailsList = ({ details }: { details: { title: string; value: ReactNode | undefined }[] }) => {
  return (
    <>
      {details.map(({ title, value }) => (
        <DetailsListItem key={title} title={title} value={value || 'N/A'} />
      ))}
    </>
  );
};
